import { TRUCK_SUBTYPE_42N, TRUCK_SUBTYPE_43N } from 'utils/constants'
import strings from 'utils/strings'

// Types to be used for layout and blocked lists
const DASH_43N_E_VAULT = 'N'
const DASH_43N_003_002 = '003-002_43N'
export const DASH_TYPE_Q_BUS_DATABOOK_CODE = '001-310'
export const DASH_TYPE_Q_RV_DATABOOK_CODE = '001-343'
export const DASH_TYPE_Q_AUPPN_DATABOOK_CODES = ['734-024', '734-025']
export const DASH_38N_E_VAULT = 'R'
const DASH_38N_003_002 = '003-002_38N'
export const DASH_42N_M2_SD = 'Q'
const DASH_M2_WING = 'H'
const DASH_M2_FLAT_G = 'G'
const DASH_M2_FLAT_K = 'K'
const OVERHEAD_35M_001 = '35m-001'
const OVERHEAD_35M_002 = '35m-002'
const OVERHEAD_35M_003 = '35m-003'
const OVERHEAD_35M_004 = '35m-004'
const OVERHEAD_35M_005 = '35m-005'
const OVERHEAD_35M_006 = '35m-006'
const OVERHEAD_35M_007 = '35m-007'
const OVERHEAD_35M_008 = '35m-008'
const OVERHEAD_35M_009 = '35m-009'
const OVERHEAD_4E1_001 = '4e1-001'
const OVERHEAD_4E1_002 = '4e1-002'
const OVERHEAD_4E1_003 = '4e1-003'
const OVERHEAD_4E1_004 = '4e1-004'
const OVERHEAD_829_075 = '829-075'

export const BUS_42N_PLUG_PANEL_NUMBER = 'TBBC232883'
export const OVERHEAD_PANEL = 'OVERHEAD_PANEL'
export const DAY_CAB = 'DAY_CAB'
export const EXTENDED_CAB = 'EXTENDED_CAB'
export const RHD_43N_38N_CODE = '003-002'
export const DIGITAL_DASH_CODE = '811-047'
export const DIGITAL_DASH_LOCATION_ID = 'AUDSP'
export const AUX_PANEL_LOCATION_ID = 'AUPNL'
export const TEM_PANEL_LOCATION_ID = 'PLTEM'
export const DIGITAL_ICU_LEFT_FILE_NAME = 'LHD Instrument Cluster Screen'
export const SLEEPER_DASH_CODES = [
  '682-090',
  '682-091',
  '682-092',
  '682-088',
  '682-093',
  '682-094',
]
export const SLEEPER_DBCODE_PREFIX = '682'
export const SLEEPER_PANEL_LOCATION_ID = 'SPANL'

export const DASH_TYPES = {
  DASH_43N_E_VAULT,
  DASH_43N_003_002,
  DASH_38N_E_VAULT,
  DASH_38N_003_002,
  DASH_42N_M2_SD,
  DASH_M2_WING,
  DASH_M2_FLAT_G,
  DASH_M2_FLAT_K,
  OVERHEAD_35M_001,
  OVERHEAD_35M_002,
  OVERHEAD_35M_003,
  OVERHEAD_35M_004,
  OVERHEAD_35M_005,
  OVERHEAD_35M_006,
  OVERHEAD_35M_007,
  OVERHEAD_35M_008,
  OVERHEAD_35M_009,
  OVERHEAD_4E1_001,
  OVERHEAD_4E1_002,
  OVERHEAD_4E1_003,
  OVERHEAD_4E1_004,
  OVERHEAD_829_075,
}

export const ROUND_SHAPES_BY_DASH_AND_DETAIL = {
  [DASH_M2_WING]: ['A', 'G', 'D', 'M', 'X'],
  [DASH_M2_FLAT_G]: ['A', 'D', 'GH', 'M', 'X'],
  [DASH_43N_E_VAULT]: ['A', 'PR', 'D-D', 'E'],
  [DASH_42N_M2_SD]: ['A', 'USB'],
  [DASH_38N_E_VAULT]: ['A', 'C', 'X'],
}

export const ROTATE_TEXT_BY_DETAIL = [
  'C',
  'F',
  'QQ',
  'JJ',
  'F',
  'Y',
  'YY',
  'SS',
  'MS',
]
export const AU_PANEL_LOCATION_PREFIX = 'AU'
export const AG_PANEL_LOCATION_PREFIX = 'AG'
export const OVERHEAD_LOCATION_PREFIX = 'UP'
export const HARDWIRED_COMPONENT = 'hardwired-component'
export const SMART_SWITCH = 'smart-switch'
export const SMART_PLEX = 'smart-plex'
export const HARDWIRED_SWITCH = 'hardwired-switch'
export const SMART_SWITCH_TYPES = [SMART_SWITCH, SMART_PLEX]
export const CUSTOM_SWITCH_WITH_GRAPHIC = 'Part__Blank_Switch'
export const ICU = 'ICU'
export const ICUC5 = 'ICUC5'
export const PANEL_PART = 'PANEL_PART'
export const UNASSIGNED_PANEL_PART = 'UNASSIGNED_PANEL_PART'
export const MSF_CAVITY_PLUG_PART = 'PLUG-MSF,SW CAVITY,WST'
export const PLUG_MSF_SW_CAVITY_P4 = 'PLUG-MSF,SW CAVITY,P4'
export const PLUG = 'PLUG'
export const TBB = 'TBB'
export const POCKET = 'POCKET'
export const MSF = 'MSF'
export const SWITCH = 'SWITCH'
export const MST = 'MST'
export const OHSSP = 'OHSSP'
export const UNKNOWN_DETAIL = 'UNKNOWN_DETAIL'
export const DETAILS_SEPERATOR = '|'
export const DASH_CODE_SEPARATOR = '_'
export const OVERHEAD_DAY_CAB_LOCATION_ID_PREFIX = 'OD'
export const OVERHEAD_EXTENDED_CAB_LOCATION_ID_PREFIX = 'OE'
export const SLEEPER_LOCATION_PREFIX = 'SR'
export const STAGED_PANEL_PART = 'STAGED'
export const POC = 'POC'

export const SWITCH_DETAIL_BY_DASH_TYPE = {
  [DASH_43N_E_VAULT]: 'JJ',
  [DASH_42N_M2_SD]: 'QQ',
  [DASH_38N_E_VAULT]: 'SS',
  [DASH_M2_FLAT_G]: 'C',
  [DASH_M2_FLAT_K]: 'C',
  [DASH_M2_WING]: 'C',
}

export const MSF_DETAIL_BY_DASH_TYPE = {
  [DASH_43N_E_VAULT]: 'J',
  [DASH_42N_M2_SD]: 'Q',
  [DASH_38N_E_VAULT]: 'S',
}

const LEFT_HAND_PANEL_LS = 'Left Hand Panel: LS'
const A_PANEL_ICU = 'A Panel: ICU'
const RIGHT_HAND_PANEL_RG = 'Right Hand Panel: RG'
const RIGHT_HAND_B_PANEL_AG = 'Right Hand B Panel: AG'
const RIGHT_HAND_B_PANEL_AUX = 'Right Hand B Panel Aux'
const UPPER_PANEL_LEFT = 'Upper Panel: Left'
const UPPER_PANEL_CENTER = 'Upper Panel: Center'
const UPPER_PANEL_RIGHT = 'Upper Panel: Right'
const AU_PANEL = 'AU Panel'
const OL_PANEL = 'OL Panel'
const OC_PANEL = 'OC Panel'
const OR_PANEL = 'OR Panel'
const SLLG_PANEL = 'Sleeper Panel 60" x 72"'
const SLSM_PANEL = 'Sleeper Panel 36" x 48"'
const SLEEPER_PANEL = 'Sleeper Panel'
const AG_PANEL = 'AG Panel'

export const DASH_LABELS = {
  LEFT_HAND_PANEL_LS,
  A_PANEL_ICU,
  RIGHT_HAND_PANEL_RG,
  RIGHT_HAND_B_PANEL_AUX,
  RIGHT_HAND_B_PANEL_AG,
  UPPER_PANEL_LEFT,
  UPPER_PANEL_CENTER,
  UPPER_PANEL_RIGHT,
  AU_PANEL,
  OL_PANEL,
  OC_PANEL,
  OR_PANEL,
  SLLG_PANEL,
  SLSM_PANEL,
  SLEEPER_PANEL,
  AG_PANEL,
}

export const overheadDashCodeKeys = {
  OVHD_DASH_35M_001: 'OVERHEAD_35M_001',
  OVHD_DASH_35M_002: 'OVERHEAD_35M_002',
  OVHD_DASH_35M_003: 'OVERHEAD_35M_003',
  OVHD_DASH_35M_004: 'OVERHEAD_35M_004',
  OVHD_DASH_35M_005: 'OVERHEAD_35M_005',
  OVHD_DASH_35M_006: 'OVERHEAD_35M_006',
  OVHD_DASH_35M_007: 'OVERHEAD_35M_007',
  OVHD_DASH_35M_008: 'OVERHEAD_35M_008',
  OVHD_DASH_35M_009: 'OVERHEAD_35M_009',
}

export const OVLHP = 'OVLHP'
export const OVRHP = 'OVRHP'
export const OVCPL = 'OVCPL'
export const OLP = 'OLP'
export const OCP = 'OCP'
export const ORP = 'ORP'
export const OEL = 'OEL'
export const OEC = 'OEC'
export const OER = 'OER'

export const OVHD_DASH_35M_001 = {
  UPL: 'M2_OVLHP',
}

export const OVHD_DASH_35M_002 = {
  UPR: 'M2_OVRHP',
}

export const OVHD_DASH_35M_003 = {
  UPC: 'M2_OVCPL_HALF',
}

export const OVHD_DASH_35M_004 = {
  UPC: 'M2_OVCPL',
}

export const OVHD_DASH_35M_005 = {
  UPL: 'M2_OVLHP',
  UPR: 'M2_OVRHP',
}

export const OVHD_DASH_35M_006 = {
  UPL: 'M2_OVLHP',
  UPC: 'M2_OVCPL_HALF',
}

export const OVHD_DASH_35M_007 = {
  UPL: 'M2_OVLHP',
  UPC: 'M2_OVCPL',
}

export const OVHD_DASH_35M_008 = {
  UPL: 'M2_OVLHP',
  UPC: 'M2_OVCPL_HALF',
  UPR: 'M2_OVRHP',
}

export const OVHD_DASH_35M_009 = {
  UPL: 'M2_OVLHP',
  UPC: 'M2_OVCPL',
  UPR: 'M2_OVRHP',
}

export const overHeadM2PanelKeys = {
  upl: 'Upper Panel: Left',
  upc: 'Upper Panel: Center',
  upr: 'Upper Panel: Right',
}

export const DETAIL = {
  A: 'A',
  J: 'J',
  JJ: 'JJ',
  HH: 'HH',
  PD: 'PD',
  Q: 'Q',
  QQ: 'QQ',
  C: 'C',
  D_D: 'D-D',
  T: 'T',
  U: 'U',
  L: 'L',
  USB: 'USB',
  B_B: 'B-B',
  A_A: 'A-A',
  G: 'G',
  BD: 'BD',
  R: 'R',
  JL: 'JL',
  DD: 'DD',
  AS: 'AS',
  D: 'D',
  F: 'F',
  AC: 'AC',
  B: 'B',
  AL: 'AL',
  S: 'S',
  AB: 'AB',
  K: 'K',
  S_F: 'S-F',
  M: 'M',
  WB: 'WB',
  GH: 'GH',
  AZ: 'AZ',
  X: 'X',
  AM: 'AM',
  SN: 'SN',
  KS: 'KS',
  DZ: 'DZ',
  BL: 'BL',
  TS: 'TS',
  JM: 'JM',
  ST: 'ST',
  FS: 'FS',
  Z: 'Z',
  SS: 'SS',
  MS: 'MS',
  DSP: 'DSP',
  F_F: 'F-F',
  AA: 'AA',
  H: 'H',
  Y: 'Y',
  YY: 'YY',
  POC: 'POC',
  PR: 'PR',
  BC: 'BC',
  MU: 'MU',
}

export const excludedLocationTypes = [MSF, MST, 'PANEL']

export const PRE_PRO_LOCATION_ERROR_CODE_01 = '01'

export const OVERHEAD_PANELS = [OLP, OCP, ORP]

export const BREAK_LOCATIONS_42N = ['LP016', 'LP017', 'LP018']
export const LP017 = 'LP017'
export const LP018 = 'LP018'
export const COMBINED_LOCATIONS_PARKING_BREAK_PANEL_NUMBERS = [
  '12-21896-000',
  '12-22194-000',
]
export const LABEL_LP017_AND_LP018 = 'LP017 & LP018'
export const AGPNL = 'AGPNL'
export const AGFAC = 'AGFAC'

export const SLEEPER = 'sleeper'
export const OVERHEAD = 'overhead'
export const DASH = 'dash'

export const LOCATION_TYPE_TBB_SWITCH = 'TBB SWITCH'
export const LOCATION_TYPE_SINGLE_SWITCH_MSF = 'SINGLE MSF'

export const DASH_TYPE_GROUPS = {
  SLEEPER,
  OVERHEAD,
  DASH,
}

// pocket locations
export const LPCT1 = 'LPCT1'
export const LPCT2 = 'LPCT2'
export const LSPCT = 'LSPCT'
export const RSPCT = 'RSPCT'
export const CSPCT = 'CSPCT'
// 4 slot MSF locations
export const LPMN1 = 'LPMN1'
export const LPMN2 = 'LPMN2'
export const LSMAN = 'LSMAN'
export const RSMAN = 'RSMAN'
export const CSMAN = 'CSMAN'

export const POCKET_LOCATIONS = [LPCT1, LPCT2, LSPCT, RSPCT, CSPCT]

export const MSF_POCKET_LOCATIONS_MAP = {
  LPCT1: LPMN1,
  LPCT2: LPMN2,
  LSPCT: LSMAN,
  RSPCT: RSMAN,
  LPMN1: LPCT1,
  LPMN2: LPCT2,
  LSMAN: LSPCT,
  RSMAN: RSPCT,
  CSMAN: CSPCT,
  CSPCT: CSMAN,
}

export const POCKET_LABELS = {
  LPCT1: strings.lower_storage_pocket_one,
  LPCT2: strings.lower_storage_pocket_two,
  LSPCT: strings.left_storage_pocket,
  RSPCT: strings.right_storage_pocket,
  CSPCT: strings.center_storage_pocket,
}

export const vehicleTypesForAddMsf = [TRUCK_SUBTYPE_42N, TRUCK_SUBTYPE_43N]

export const SWITCH_DETAIL_BY_MODEL_CODE = {
  N: 'JJ',
  R: 'SS',
  G: 'C',
  H: 'C',
  K: 'C',
  Q: 'QQ',
  TBB: 'B-B',
}

export const CEEA_DASHBOARD_TYPES = ['N', 'Q', 'R']
export const MULTI_USE_DISPLAY_DB_CODE = '746-143'
